import { render } from "./CharterList.vue?vue&type=template&id=19b49510&scoped=true"
import script from "./CharterList.vue?vue&type=script&lang=js"
export * from "./CharterList.vue?vue&type=script&lang=js"

import "./CharterList.vue?vue&type=style&index=0&id=19b49510&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b49510"]])

export default __exports__